import React from 'react';
import * as styles from './SectionMoreInfo.module.scss';
import { DEFAULT_ICON_ORDER } from '../../constants';
import { LinkIcon } from '../LinkIcon/LinkIcon';

const DEFAULT_ORDER = 10000;

function orderIcons(pageContextData, customIconsDataRaw) {
  const defaultIcons = DEFAULT_ICON_ORDER.reduce((acc, currIcon) => {
    const link = pageContextData[currIcon.icon];

    if (link) {
      const orderKey = currIcon.icon + '_Order';
      const order =
        pageContextData[orderKey] != null
          ? pageContextData[orderKey]
          : DEFAULT_ORDER;

      const redirect = currIcon.icon === 'Exclusive_Content';

      acc.push({
        icon: redirect ? `/${pageContextData.Name}/out` : link,
        type: currIcon.icon,
        order: order,
        text: currIcon.text,
        redirect: redirect,
      });
    }

    return acc;
  }, []);

  const customIcons = customIconsDataRaw.reduce((acc, currIcon) => {
    const customIcon = currIcon?.node?.data;

    if (customIcon) {
      const order = customIcon?.Order ?? DEFAULT_ORDER;

      acc.push({
        icon: customIcon.Custom_Link_URL,
        text: customIcon.Custom_Link_Text,
        order: order,
        type: 'Star',
        redirect: false,
      });
    }

    return acc;
  }, []);

  const finalIcons = [...defaultIcons, ...customIcons];
  finalIcons.sort((a, b) => a.order - b.order);

  return finalIcons;
}

const SectionMoreInfo = ({ pageContext }) => {
  const icons = orderIcons(pageContext.data, pageContext?.customLinks?.edges);
  return (
    <section className={styles.sectionMoreInfo}>
      <h4>More info</h4>
      <ul className={styles.socialMedia}>
        {icons.map((iconData) => {
          return <LinkIcon {...iconData} key={iconData.icon} />;
        })}
      </ul>
    </section>
  );
};

export default SectionMoreInfo;
